module.exports = __webpack_public_path__ + "img/1.723c127f.png";